export default "__VITE_PUBLIC_ASSET__597cf68b__"